var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loading' : _vm.isLoadingContent}},[(_vm.emptyBasket)?_c('basket-empty'):_vm._e(),(_vm.notEmptyBasket)?_c('basket-content'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }